/**
 * 프로젝트에서 사용되는 상수 정의
 */

// 음성 타입 옵션
export const VOICE_OPTIONS = [
  { value: 'female', label: '👩 여자 음성 (SunHi)' },
  { value: 'male', label: '👨 남자 음성 (InJoon)' }
]

// 자막 위치 매핑 (0-100 슬라이더 값을 위치로 변환)
export const SUBTITLE_POSITION_MAPPING = {
  0: 'top',      // 상단
  50: 'center',  // 중앙  
  100: 'bottom'  // 하단
}

export const POSITION_TO_SLIDER = {
  'top': 0,
  'center': 50,
  'bottom': 100
}


// 위치 표시용 레이블
export const POSITION_LABELS = {
  'top': '상단',
  'center': '중앙',
  'bottom': '하단'
}

// 자막 방식 옵션 (Drawtext만 사용)
export const SUBTITLE_METHODS = [
  { value: 'drawtext', label: '🔥 Drawtext (100% 안정)' }
]

// 슬라이더 값을 실제 값으로 매핑하는 함수들
export const mapPositionSliderToPixel = (sliderValue) => {
  // 0-100 슬라이더를 1870-50픽셀로 변환 (0%=하단, 100%=상단)
  // 0% → 하단(1870px), 80% → 상단 근처(414px), 100% → 상단(50px)
  return Math.round(1870 - (sliderValue / 100) * 1820)
}

export const mapPixelToPositionSlider = (pixelValue) => {
  // 픽셀값을 0-100 슬라이더로 역변환 (반전)
  return Math.round((1870 - pixelValue) / 1820 * 100)
}


// 기본 자막 설정 (픽셀 단위 위치 사용)
export const DEFAULT_SUBTITLE_SETTINGS = {
  enabled: true,     // 자막 활성화/비활성화
  fontSize: 50,      // 크기 50px
  fontColor: 'white',
  borderWidth: 3,
  borderColor: 'black',
  position: 'pixel', // 픽셀 모드로 변경
  yPosition: 1546,   // 20% 위치에 해당하는 픽셀 값 (하단 근처)
  horizontalAlign: 'center',
  method: 'drawtext',
  // 배경 설정
  backgroundEnabled: true,
  backgroundColor: '#000000',
  backgroundOpacity: 0.7,
  backgroundPadding: 10
}

// 기본 제목 설정
export const DEFAULT_TITLE_SETTINGS = {
  enabled: true,     // 제목 표시 여부 (기본으로 켜짐)
  text: '',          // 제목 텍스트 (비어있음 - 사용자가 입력)
  fontSize: 65,      // 크기
  fontColor: '#FFFFFF',
  fontWeight: 'heavy',  // 폰트 굵기 (heavy, extrabold, bold)
  yPosition: 100,    // 상단에서 100px 위치 (더 위쪽)
  backgroundEnabled: true,
  backgroundColor: '#000000',
  backgroundOpacity: 0.8,
  backgroundPadding: 15,
  displayDuration: 'full'  // full, 3, 5, 10 (초)
}

// 기본 영상 설정
export const DEFAULT_VIDEO_SETTINGS = {
  videoYOffset: 0,         // -200 ~ +200px (Canvas 기준 픽셀 오프셋)
  fillTo916: false         // false: 원본 비율 유지(중앙 배치), true: 9:16 채우기
}